import React, {useState} from "react";
import I18n from 'i18n.js.erb'
import { getArtwork, parseBlueprintImageNameAndEdition } from "../../utils/utils";
import PlaceholderImage from "./PlaceholderImage.jsx"
import IconTooltip from "./IconTooltip";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { displayTranslations } from "../../utils/utils";
import TextOverlayOnImage from "./TextOverlayOnImage";

const SealedProductBlockItem = ({
    blueprintImage,
    onCheckHandler,
    onKeyDownQuantity,
    onChangeQuantity,
    handleNavigation,
    era_index,
    era_name,
    blueprint_image_index
  }) => {

  const [isSmallDesktop, setIsSmallDesktop] = useState(false)


  $(window).resize(function () {
    if ($(window).innerWidth() < 1400 && !isSmallDesktop) {
      setIsSmallDesktop(true)
    }
    if ($(window).innerWidth() > 1400 && isSmallDesktop) {
      setIsSmallDesktop(false)
    }
  });

  const blueprintImageNames = displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language)

  return (
    <React.Fragment>
      <div className={`${isSmallDesktop ? 'col-lg-4':'col-lg-2'} col-md-4 col-sx-8 mb-5 mb-md-0 mt-5 mt-md-0 p-md-1 p-lg-0 d-none d-md-block`}>
        <div
          className="custom-header container position-relative m-1 p-sm-1 text-dark text-center rounded ml-auto mr-auto border-radius-none-imp"
          key={blueprintImage.id}
          data-id={blueprintImage.id}
          style={
            blueprintImage.checked ? {
                backgroundColor: "trasparent",
                border: "1px solid #000000",
                boxShadow: "5px 5px 5px rgba(68, 68, 68, 0.6)",
              }
              : {}
          }
          onClick={(e) => {
            e.preventDefault()
            onCheckHandler(e, blueprintImage.id);
          }}
        >
          <label htmlFor={blueprintImage.id} className={`${blueprintImage.encasing_id && 'cursor-pointer'}`}>
            <div
              className="d-flex justify-content-center align-items-center"
            >
              <div className="noselect minH-175px d-flex align-items-center">
                {blueprintImageNames.length > 1 ? (
                  <React.Fragment>
                    <div className="noselect">
                      <p className="font-title text-space text-dark" style={{fontWeight: "500"}}>
                        {
                          parseBlueprintImageNameAndEdition(blueprintImage.game_name, blueprintImage.edition, blueprintImageNames[0])
                        }
                      </p>
                      <small className="text-space text-dark">
                        { blueprintImageNames[1] }
                      </small>
                    </div>
                  </React.Fragment>
                ) : (
                  <div className="noselect">
                    <p className="font-title text-space text-dark" style={{fontWeight: "500"}}>
                      {
                        parseBlueprintImageNameAndEdition(blueprintImage.game_name, blueprintImage.edition, blueprintImageNames[0])
                      }
                    </p>
                  </div>
                )}
              </div>
            </div>

            <input
              type="checkbox"
              checked={ blueprintImage.checked === true }
              id={blueprintImage.id}
              onChange={() => {}}
              className={`option-input checkbox ${blueprintImage.checked ? "checkbox-cards-list" : "d-none"}`}
            />

            <div id={"blueprint_image_" + blueprintImage.id} className="position-relative">

              {blueprintImage.already_in_wishlist > 0 &&
              <div className="position-absolute container-product-inside-wishlist-icon"
                   onClick={(e) => handleNavigation(e, null, `/wishlists/${blueprintImage.already_in_wishlist}/edit`)}>
                <IconTooltip
                  tooltipPosition={'top'}
                  tooltipIcon={'fas fa-heart'}
                  tooltipTitle={I18n.t('js.indexSealedPage.productInwishlistTitle')}
                  tooltipContent={I18n.t('js.indexSealedPage.productInwishlistContent')}
                  iconColor={'#00a2dd'}
                />
              </div>
              }

              {
                <div
                  className="font-card-number m-auto position-absolute container-language-of-product-icon"
                  style={{ maxWidth: "25px", minWidth: "20px" }}
                >
                  <img src={window.location.origin + `/images/flags/${blueprintImage.language}.png`}
                       style={{ maxHeight: "20px", }} alt="" />
                </div>
              }

              {
                blueprintImage.expansion_icon_url &&
                <div
                  className="font-card-number m-auto position-absolute container-expansion-icon-of-product-icon"
                  style={{maxWidth: "35px", minWidth: "30px"}}
                >
                  <img src={blueprintImage.expansion_icon_url}
                       style={{ maxHeight: "30px",}} alt=""/>
                </div>
              }

              {
                blueprintImage.medium_image_url ?
                  <div className="d-flex justify-content-center position-relative text-center">
                    <img
                      className="image-card m-auto"
                      style={{borderRadius: "7px"}}
                      src={blueprintImage.medium_image_url}
                      alt=""
                    />

                    {
                      !blueprintImage.encasing_id &&
                        <TextOverlayOnImage
                          textOverlay={I18n.t('js.common.notGradableProduct')}
                          size={'medium'}
                          type={'red-overlay'}
                        />
                    }
                  </div>
                :
                  <PlaceholderImage
                    size={'medium'}
                    textOverlay={getArtwork(blueprintImage)}
                    showNotGradableProductOverlay={!blueprintImage.encasing_id}
                  />
              }
            </div>


            <div className="mt-1">
              <div className="row d-flex justify-content-center">
                <div className="col-12 max-w-200px">
                  <button
                    id={"product_info_" + blueprintImage.id}
                    className="button -regular noselect col-12 mt-1 bg-dark rounded text-space text-light-gray"
                    style={{fontSize: "0.9rem"}}
                    onClick={(e) => handleNavigation(e, blueprintImage, `/blueprint_images/${blueprintImage.id}`)}
                  >
                    {I18n.t('js.indexSealedPage.productInfo')}
                  </button>
                </div>
                <div
                  className="col-12 d-flex card-number noselect mt-2 max-w-200px align-items-center justify-content-between">
                  <div className="col-4 text-right ml-2 mt-2 noselect p-0">
                    <p className="text-space text-dark-gray" style={{fontSize: "0.8rem", fontWeight: "500"}}>
                      {I18n.t('js.common.quantity')}:
                    </p>
                  </div>

                  <div className="col-6 text-left p-0">
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-top`}>
                          <p>{I18n.t('js.common.quantityTooltipContent')}</p>
                        </Tooltip>
                      }
                    >
                      <div>
                    <input
                      className="form-control"
                      value={
                        blueprintImage.quantity ? blueprintImage.quantity : ''
                      }
                      name="bluprint_image_quantity"
                      id={"blueprint_image_quantity_" + blueprintImage.id}
                      type="number"
                      style={{width: "70px"}}
                      onKeyDown={(e) => onKeyDownQuantity(e)}
                      onClick={(e) => e.stopPropagation()}
                      onChange={ (e) => onChangeQuantity(e, era_index, era_name, blueprint_image_index) }
                      data-id={blueprintImage.id}
                      disabled={!blueprintImage.checked === true}
                    />
                      </div>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
          </label>
        </div>
      </div>



      <div className="d-md-none col-6 p-2 text-center m-auto">

        <div
          style={
            blueprintImage.checked ? {
                backgroundColor: "trasparent",
                 border: "1px solid #000000",
                 boxShadow: "5px 5px 5px rgba(68, 68, 68, 0.6)",
              }
              : {}
          }
        >
          <label htmlFor={blueprintImage.id}>
            <div id={"blueprint_image_" + blueprintImage.id} className="position-relative">

              {
                blueprintImage.already_in_wishlist > 0 &&
                  <div className="position-absolute container-product-inside-wishlist-icon pt-2"
                       onClick={(e) => handleNavigation(e, null, `/wishlists/${blueprintImage.already_in_wishlist}/edit`)}>
                    <IconTooltip
                      tooltipPosition={'top'}
                      tooltipIcon={'fas fa-heart'}
                      tooltipTitle={I18n.t('js.indexSealedPage.productInwishlistTitle')}
                      tooltipContent={I18n.t('js.indexSealedPage.productInwishlistContent')}
                      iconColor={'#00a2dd'}
                    />
                  </div>
              }

              <div
                className="font-card-number m-auto position-absolute container-language-of-product-icon"
                style={{maxWidth: "25px", minWidth: "20px"}}
              >
                <img src={window.location.origin + `/images/flags/${blueprintImage.language}.png`}
                     style={{ maxHeight: "20px",}} alt=""/>
              </div>

              {
                blueprintImage.expansion_icon_url &&
                  <div
                    className="font-card-number m-auto position-absolute container-expansion-icon-of-product-icon"
                    style={{maxWidth: "25px", minWidth: "20px"}}
                  >
                    <img src={blueprintImage.expansion_icon_url}
                         style={{ maxHeight: "20px",}} alt=""/>
                  </div>
              }

              <div className="transform-scale-09">
                {
                  blueprintImage.medium_image_url ?
                    <div className="d-flex justify-content-center position-relative text-center">
                      <img
                        className="image-card m-auto"
                        style={{borderRadius: "7px"}}
                        src={blueprintImage.medium_image_url}
                        alt=""
                      />

                      {
                        !blueprintImage.encasing_id &&
                          <TextOverlayOnImage
                            textOverlay={I18n.t('js.common.notGradableProduct')}
                            size={'medium'}
                            type={'red-overlay'}
                          />
                      }
                    </div>
                  :
                    <PlaceholderImage
                      size={'medium'}
                      textOverlay={getArtwork(blueprintImage)}
                      showNotGradableProductOverlay={!blueprintImage.encasing_id}
                    />
                }
              </div>

              <button
                className="button -regular noselect col-10 ml-auto mr-auto mt-2 bg-dark rounded text-space text-light-gray"
                style={{fontSize: "0.9rem"}}
                onClick={(e) => handleNavigation(e, blueprintImage, `/blueprint_images/${blueprintImage.id}`)}
              >
                {I18n.t('js.indexSealedPage.productInfo')}
              </button>
            </div>
            <div
              className="col-12 d-flex card-number noselect mt-2 max-w-200px align-items-center justify-content-between">
                <div className="col-4 text-right ml-2 mt-2 noselect p-0">
                  <p className="text-space text-dark-gray" style={{fontSize: "0.8rem", fontWeight: "500"}}>
                    {I18n.t('js.common.quantity')}:
                  </p>
                </div>
                <div className="col-6 text-left p-0">
                  <input
                    className="form-control quantity-name"
                    disabled={!blueprintImage.checked === true}
                    value={blueprintImage.quantity ? blueprintImage.quantity : ''}
                    name="bluprint_image_quantity"
                    type="number"
                    style={{ width: "77px" }}
                    onChange={(e) => onChangeQuantity(e, era_index, era_name, blueprint_image_index)}
                    data-id={blueprintImage.id}
                  />
                </div>
              </div>

            <input
              type="checkbox"
              checked={ blueprintImage.checked === true }
              id={blueprintImage.id}
              onChange={() => {}}
              className={`option-input checkbox ${blueprintImage.checked ? "checkbox-cards-list" : "d-none"}`}
            />
          </label>
        </div>
      </div>
    </React.Fragment>
  )};

export default SealedProductBlockItem;
